// TODO add missing paths (/users, management paths) VIB-765

export default {
  VI: '/virtualIssues',
  VIsNonLive: '/virtualIssues/nonLive',
  societies: '/societies',
  society: '/societies/:id',
};
